export const HOPPER_PRO_COPY_COMPLIANCE = "ConsumerHopperProCopyComplianceV1";
